import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from '../../../../classes/Client';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  clientData: Client = new Client( );

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  constructor ( 
    private route: ActivatedRoute, 
    private model: ModelService, 
    private global: GlobalService, 
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Client Details' );  
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getClientDataByID( this.id, ( client ) => {
         this.contentVisible = true;
         this.clientData = client;
       });
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/clients/client/client.component.ts